import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import ObrasService from '../../../../../services/obras-auth';
import { Link, useParams, Navigate } from 'react-router-dom';
import Moment from 'moment';

const Obras = () => {
    let { id } = useParams()

    const [nome, setNome] = useState("");
    const [local, setLocal] = useState("");
    const [dataInicio, setDataInicio] = useState("");
    const [etapa, setEtapa] = useState("");
    const [valor, setValor] = useState("");
    const [empresa, setEmpresa] = useState("");
    const [ano, setAno] = useState("");
    const [percentualConcluido, setPercentualConcluido] = useState("");
    const [situacao, setSituacao] = useState("");
    const [previsaoConclusao, setPrevisaoConclusao] = useState("");
    const [motivoParalizacao, setMotivoParalizacao] = useState("");
    const [responsavelParalizacao, setResponsavelParalizacao] = useState("");
    const [previsaoReinicio, setPrevisaoReinicio] = useState("");
    const [para, setPara] = useState(false);
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchObra(id) {
        const response = await ObrasService.obrEdit(id);
        setNome(response.data["nome"]);
        setLocal(response.data["local"]);
        setAno(response.data["ano"]);
        setDataInicio(Moment(response.data["dataInicio"]).utc(false).format("yyyy-MM-DD"));
        setEtapa(response.data["etapa"]);
        setValor(response.data["valor"]);
        setEmpresa(response.data["empresa"]);
        setPercentualConcluido(response.data["percentualConcluido"]);
        setSituacao(response.data["situacao"]);
        setPrevisaoConclusao(response.data["previsaoConclusao"]);
        response.data["motivoParalizacao"] ? setMotivoParalizacao(response.data["motivoParalizacao"]) : setMotivoParalizacao("");
        response.data["responsavelParalizacao"] ? setResponsavelParalizacao(response.data["responsavelParalizacao"]) : setResponsavelParalizacao("");
        response.data["previsaoReinicio"] ? setPrevisaoReinicio(response.data["previsaoReinicio"]) : setPrevisaoReinicio("");
    }

    useEffect(() => {
        fetchObra(id);
    }, [id]);

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const obra = await ObrasService.editar(id, {
                nome: nome,
                local: local,
                ano: ano,
                dataInicio: dataInicio,
                etapa: etapa,
                valor: valor,
                empresa: empresa,
                percentualConcluido: percentualConcluido,
                situacao: situacao,
                previsaoConclusao: previsaoConclusao,
                motivoParalizacao: motivoParalizacao,
                responsavelParalizacao: responsavelParalizacao,
                previsaoReinicio: previsaoReinicio
            })
            if (obra.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    const trataSit = async (e) => {
        setSituacao(e)
        e === "Paralizada" ? setPara(true) : setPara(false)
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome da Obra"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="local">
                                <FloatingLabel
                                    label="Local da Obra"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="local"
                                        value={local}
                                        onChange={e => setLocal(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataInicio">
                                <FloatingLabel
                                    label="Data de Início"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataInicio"
                                        value={dataInicio}
                                        onChange={e => setDataInicio(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="previsaoConclusao">
                                <FloatingLabel
                                    label="Previsão de Conclusão (Mês/Ano)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="previsaoConclusao"
                                        value={previsaoConclusao}
                                        onChange={e => setPrevisaoConclusao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="percentualConcluido">
                                <FloatingLabel
                                    label="% Concluído (Ex: 7%)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="percentualConcluido"
                                        value={percentualConcluido}
                                        onChange={e => setPercentualConcluido(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Valor da Obra">
                                <FloatingLabel
                                    label="Valor da Obra (2.000 = 2000)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={4}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Situação"
                                        name="situacao"
                                        onChange={e => trataSit(e.target.value)}
                                    >
                                        <option value={situacao}>{situacao}</option>
                                        <option value="Em Andamento">Em Andamento</option>
                                        <option value="Paralizada">Paralizada</option>
                                        <option value="Concluída">Concluída</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Empresa">
                                <FloatingLabel
                                    label="Empresa Responsável"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="empresa"
                                        value={empresa}
                                        onChange={e => setEmpresa(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Etapa">
                                <FloatingLabel
                                    label="Etapa"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="etapa"
                                        value={etapa}
                                        onChange={e => setEtapa(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        {para ?
                            <Fragment>
                                <Col xs={12}>
                                    <Form.Group className="mb-3" controlId="Motivo paralização">
                                        <FloatingLabel
                                            label="Motivo da Paralização"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="textarea"
                                                name="motivoParalizacao"
                                                value={motivoParalizacao}
                                                onChange={e => setMotivoParalizacao(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="Responsável pela paralização">
                                        <FloatingLabel
                                            label="Responsável pela Paralização"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="responsavelParalizacao"
                                                value={responsavelParalizacao}
                                                onChange={e => setResponsavelParalizacao(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="previsaoConclusao">
                                        <FloatingLabel
                                            label="Previsão de Reinicio (Mês/Ano)"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="previsaoReinicio"
                                                value={previsaoReinicio}
                                                onChange={e => setPrevisaoReinicio(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                            </Fragment>
                            : null}
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/obras/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Obra editada com sucesso!</Alert>
                <Navigate to={'/restrito/obras/listar'} />
            </Fragment>
        )
    }
}

export default Obras;